import TableCell from "@material-ui/core/TableCell";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { ListTable } from "../../../../components/list_table";
import { IAsyncData } from "../../../../core/models";
import { IAppReduxState } from "../../../../redux/store";
import { ROUTES } from "../../../../routes";
import { IProductHistory } from "../../data/entities";
import { productHistoryReduxActions } from "../state/state";

export const ProductHistoryList: React.FC = () => {
  const dispatch = useDispatch();
  const { search } = useLocation();

  useEffect(() => {
    dispatch(productHistoryReduxActions.getHistoryList(search));
  }, [dispatch, search]);
  const productHistoryListBranch = useSelector<IAppReduxState, IAsyncData<IProductHistory[]>>(
    (state) => state.productHistory.historyList,
  );

  return (
    <div>
      <ListTable<IProductHistory>
        branch={productHistoryListBranch}
        route={ROUTES.productHistory}
        renderHeader={() => (
          <>
            <TableCell>Mal</TableCell>
            <TableCell>Çirkli çəki</TableCell>
            <TableCell>İtki faizi</TableCell>
            <TableCell>Təmiz çəki</TableCell>
            <TableCell>Ümumi qiymət</TableCell>
            <TableCell>Orta qiymət</TableCell>
          </>
        )}
        renderRow={(productHistory) => (
          <>
            <TableCell>{productHistory.product.name}</TableCell>
            <TableCell>{productHistory.dirtyWeightAfter} kq</TableCell>
            <TableCell>{productHistory.wastePercentAfter} %</TableCell>
            <TableCell>{productHistory.cleanWeightAfter} kq</TableCell>
            <TableCell>{productHistory.totalPriceAfter} AZN</TableCell>
            <TableCell>{productHistory.priceAfter} AZN</TableCell>
          </>
        )}
      />
    </div>
  );
};
